import { ITableService } from '../../../common/interfaces/table/table-service.interface';

export abstract class AbstractLmtActivityService extends ITableService {}
